// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: var(--theme-font-family);
}

.content__wrapper {
  background-color: var(--bs-body-bg);
}

/* Resets */
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type='number'] {
  /* -moz-appearance: textfield; */
}

::-webkit-input-placeholder {
  color: var(---tertiary) !important;
}

::-ms-input-placeholder {
  color: var(---tertiary) !important;
}

::placeholder {
  color: var(---tertiary) !important;
}

a {
  color: var(--primary);
  text-decoration: none;
}

/* O foco também sublinha: sem isso o link focado por teclado não tem nenhuma
   indicação, já que o tema não deixa anel de foco nos links. */
a:hover,
a:focus-visible {
  text-decoration: underline;
}

button {
  font-family: var(--theme-font-family);
  background: none;
  border: none;
  padding: 0;
  -webkit-tap-highlight-color: transparent;
  box-shadow: none;
}

button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button;
  cursor: pointer;
}

button:focus {
  outline: 0;
}
`, "",{"version":3,"sources":["webpack://./src/main.css"],"names":[],"mappings":"AAAA;EACE,qCAAqC;AACvC;;AAEA;EACE,mCAAmC;AACrC;;AAEA,WAAW;AACX,gCAAgC;AAChC;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA,YAAY;AACZ;EACE,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;+DAC+D;AAC/D;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;;;;EAIE,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ","sourcesContent":["body {\n  font-family: var(--theme-font-family);\n}\n\n.content__wrapper {\n  background-color: var(--bs-body-bg);\n}\n\n/* Resets */\n/* Chrome, Safari, Edge, Opera */\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ninput[type='number'] {\n  /* -moz-appearance: textfield; */\n}\n\n::-webkit-input-placeholder {\n  color: var(---tertiary) !important;\n}\n\n::-ms-input-placeholder {\n  color: var(---tertiary) !important;\n}\n\n::placeholder {\n  color: var(---tertiary) !important;\n}\n\na {\n  color: var(--primary);\n  text-decoration: none;\n}\n\n/* O foco também sublinha: sem isso o link focado por teclado não tem nenhuma\n   indicação, já que o tema não deixa anel de foco nos links. */\na:hover,\na:focus-visible {\n  text-decoration: underline;\n}\n\nbutton {\n  font-family: var(--theme-font-family);\n  background: none;\n  border: none;\n  padding: 0;\n  -webkit-tap-highlight-color: transparent;\n  box-shadow: none;\n}\n\nbutton,\n[type='button'],\n[type='reset'],\n[type='submit'] {\n  -webkit-appearance: button;\n  cursor: pointer;\n}\n\nbutton:focus {\n  outline: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
